// extracted by mini-css-extract-plugin
export default {"wrap":"QF-z","fullWidth":"RF-z","hideOnDesktop":"SF-z","content":"TF-z","hasOpenedNav":"UF-z","crumbsList":"VF-z","dropdownsWrap":"WF-z"};